export function getImportResultState(imported: number, skipped: number) {
  if (imported === 0) return "failure";
  return skipped > 0 ? "partial" : "success";
}
